export const SET_SSO = 'SET_SSO';
export const CLEAR_SSO = 'CLEAR_SSO';

export const clearSSO = {
  type: CLEAR_SSO,
}

export const setSSO = (data) => {
  return {
    type: SET_SSO,
    payload: data,
  }
}